import { z } from 'zod';
export const MemoryIdParamSchema = z.object({
    memoryId: z.string().uuid(),
});
export const MemorySchema = z.object({
    id: z.string().uuid(),
    content: z.string(),
    source: z.enum(['explicit', 'inferred']),
    confirmed: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
//# sourceMappingURL=memory.schema.js.map